import {
	RESET_AUTH,
	FETCH_USER,
	FAIL_FETCH_USER,
	LOGIN,
	LOGOUT
} from '../actions';

const initialState = {
    isPrepared: false,
    isLoggedIn: false,
    user: {
		UserID : undefined,
		UserPassword : undefined,
		UserName : undefined,
	},
    isFetching: false,
    error: undefined,
    jwt: '',
};

export default function authSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
	
	switch (action.type) {
		case RESET_AUTH:
			ret.isFetching = false;
			ret.error = undefined;
			return ret;
        case FETCH_USER:
			ret.isFetching = true;
			ret.error = undefined;
			return ret;
		case FAIL_FETCH_USER:
			ret.isFetching = false;
			ret.error = action.payload.err;
			return ret;
		case LOGIN:
			ret.isPrepared= true;
			ret.isLoggedIn= true;
			ret.user =  {
				UserID : action.payload.UserID,
				UserPassword : action.payload.UserPassword,
				UserName : action.payload.UserName,
				CustomerCD : action.payload.CustomerCD,
			};
			ret.isFetching = false;
			ret.error = undefined;
			ret.jwt = action.payload.jwt;
			return ret;
		case LOGOUT:
			ret.isPrepared = true;
			ret.isLoggedIn= false;
			ret.user = {
				UserID : undefined,
				UserPassword : undefined,
				UserName : undefined,
			};
			ret.error = 'ログアウトされました';
			return ret;
		default:
			return state;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/auth.js